import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    radio: {
        base: 'h-4 w-4 border border-gray-300 focus:ring-2 focus:ring-primary-500 text-primary-600 disabled:opacity-50',
    },
}).radio;
